import { useEntityUrl } from 'framework/routing';

export const ACCOUNT_PATH = '/crm/accounts';

const useAccountUrl = () => {
  return useEntityUrl({
    baseLink: ACCOUNT_PATH,
    timelinePostfix: 'activities',
  });
};

export default useAccountUrl;
